import LookupMenu from './LookupMenu';

export default LookupMenu;
